export default {
      getButton(state: { buttons_allowed: Array<any> }) {
          return state.buttons_allowed;
      },
}
